<template>
    <div class="career-page">
        <div class="career-page__meta">
            <span class="career-page__date js-get-date">{{ now }}</span>
        </div>
        <div v-if="isShowCareer" class="career-wrapper">
            <div class="career-container">
                <div class="career-title">
                    <h2 class="gradient-text">Lộ trình</h2>
                    <h2 class="gradient-text">thăng tiến</h2>
                </div>
                <div v-if="!isMobile" class="career-roadmap">
                    <RoadmapTrack ref="track"/>
                    <RoadmapPoint
                        v-for="level in levels"
                        :key="level.id"
                        :level="level"
                    />
                    <EmployeeAvatar
                        :current-level="currentLevel"
                        :total-levels="levels.length"
                        :path-selector="'#roadmap-path'"
                        :levels="levels"
                        :stops="levelStops"
                    />
                </div>
                <div v-else class="career-mobile">
                    <div class="special-notification">
                        <img class="employee-level" src="/media/images/hello.gif" alt="employee flipped" />
                        <div class="message-user">
                            <span>
                                Chúc mừng bạn đang ở vị trí
                                <span style="font-weight: 700">{{ currentLevel }}.</span>
                                Cố gắng lên level tiếp theo nhé!
                            </span>
                        </div>
                    </div>
                </div>
                <div class="career-notification">
                    <NotificationDashboard :query="{is_special: 1}"/>
                </div>
            </div>
            <Ranking/>
        </div>
        <div v-else class="career-dashboard">
            <el-row :gutter="20" class="career-dashboard__grid">
                <el-col :xs="24" :sm="24" :md="12" :lg="9" :xl="8">
                    <div class="career-summary">
                        <h1 class="career-summary__title">Chào <span>{{ currentUser?.name }}</span>, Hôm nay bạn đã sẵn sàng chưa?</h1>
                        <div class="career-summary__card bg-warning-400 text-white position-relative">
                            <div class="career-summary__body">
                                <small>Vị trí hiện tại</small>
                                <h1 class="mb-1">{{ currentUser?.account_type?.name }} {{ currentUser?.profile?.business_level?.name ?? '' }}</h1>
                                <small v-if="isPartTime" class="m-0 l-h-n mt-1 career-summary__badge">Cộng tác viên</small>
                            </div>
                            <router-link :to="{ name: 'profile' }" class="small-box-footer career-summary__link">
                                Xem thêm
                                <i class="fas fa-arrow-circle-right"></i>
                            </router-link>
                        </div>
                    </div>
                </el-col>
                <el-col v-if="currentUser.profile.account_type_id != candidate" :xs="24" :sm="24" :md="12" :lg="15" :xl="16">
                    <leader-board-component></leader-board-component>
                </el-col>
            </el-row>
        </div>

        <el-dialog title="Nhắc nhở thêm tài khoản ngân hàng" width="30%" class="responsive" :visible.sync="dialogVisible">
            <complete-bank-account-dialog></complete-bank-account-dialog>
        </el-dialog>
        </div>
</template>

<script>

import RoadmapTrack from "@/views/pages/career-roadmap/component/RoadmapTrack.vue";
import RoadmapPoint from "@/views/pages/career-roadmap/component/RoadmapPoint.vue";
import EmployeeAvatar from "@/views/pages/career-roadmap/component/EmployeeAvatar.vue";
import Ranking from "@/views/pages/career-roadmap/component/Ranking.vue";
import {GET_CURRENT_LEVEL_USER} from "@/core/services/store/user/users.module";
import NotificationDashboard from "../dashboard-leader/component/NotificationDashboard.vue";
import {mapGetters, mapState} from "vuex";
import CompleteBankAccountDialog from "./component/CompleteBankAccountDialog";

import {
    BOD,
    GDKV,
    GDVP,
    GDVUNG,
    SALE_EXPERT,
    SALE_INTERN,
    SALE_LEADER,
    SALE_MEMBER,
    HANH_CHINH_KHU_VUC,
    UNG_VIEN
} from "@/core/config/accountTypeOption";
import {DEPARTMENT_LEADER, LEADER, LEADER_GROUP, STAFF} from "@/common/define";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import LeaderBoardComponent from "../dashboard-leader/component/LeaderBoardComponent";

export default {
    name: 'CareerRoadmap',
    components: {NotificationDashboard, Ranking, RoadmapTrack, RoadmapPoint, EmployeeAvatar, LeaderBoardComponent, CompleteBankAccountDialog},
    data() {
        return {
            isMobile: window.innerWidth < 768,
            isTablet: window.innerWidth <= 1024,
            levels: [],
            isPartTime: false,
            now: null,
            levelImages: {
                1: "/media/trainee.png",
                2: "/media/junior.png",
                3: "/media/member1.png",
                4: "/media/member2.png",
                5: "/media/senior1.png",
                6: "/media/senior2.png"
            },
            levelStops: [
                { t: 0.38, offset: { x: 0, y: -170 } },
                { t: 0.32, offset: { x: 0, y: -110 } },
                { t: 0.19, offset: { x: -5, y: 100 } },
                { t: 0.25, offset: { x: 0, y: -220 } },
                { t: 0.14, offset: { x: 0, y: -110 } },
                { t: 0.14, offset: { x: 0, y: -430 } },
            ],
            levelStopsSpecial: [
                { t: 0.38, offset: { x: 0, y: -220 } },
                { t: 0.32, offset: { x: 0, y: -140 } },
                { t: 0.19, offset: { x: 20, y: 100 } },
                { t: 0.25, offset: { x: 50, y: -260 } },
                { t: 0.14, offset: { x: 0, y: -140 } },
                { t: 0.14, offset: { x: 0, y: -455 } },
            ],
            currentLevel: 'Trainee',
            isShowCareer: false,
            dialogVisible: false,
            candidate: UNG_VIEN
        }
    },
    async created() {
        if (!this.currentUser.bank_accounts.length)
        {
            this.dialogVisible = true;
        }
        await this.getCurrentLevel()
    },
    computed: {
        ...mapState({
            errors: state => state.auth.errors
        }),
        ...mapGetters(['currentUser']),
        isSpecial() {
            return window.innerWidth === 1440 || window.innerWidth === 2560
        }
    },
    mounted() {
        this.now = this.$moment().format('dddd - D/M/Y');
        let accountTypeId = this.currentUser && this.currentUser.account_type ? this.currentUser.account_type.id : '';
        this.showCareer(accountTypeId);
        if ([SALE_INTERN, SALE_MEMBER, SALE_EXPERT, SALE_LEADER, GDVP, GDKV, GDVUNG, BOD].includes(accountTypeId)) {
            this.$router.push({ name: 'dashboard-leader' });
        }
        this.$nextTick(() => {
            setTimeout(() => {
                this.computeLevelPositions()
            }, 200)
        })
        window.addEventListener("resize", this.onResize, { passive: true })
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "", icon: ''}
        ]);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize)
    },
    watch: {
        levelStops: {
            handler() {
                this.$nextTick(() => this.computeLevelPositions())
            },
            deep: true
        },
        isShowCareer: {
            handler(newVal) {
                if (newVal) {
                    this.$nextTick(() => {
                        this.computeLevelPositions()
                    })
                }
            }
        }
    },
    methods: {
        showCareer(accountType) {
            const tabs = [DEPARTMENT_LEADER, LEADER, LEADER_GROUP, STAFF];
            this.isPartTime = !!this.currentUser?.profile?.is_collaborators;
            this.isShowCareer = tabs.includes(accountType)
        },
        onResize() {
            this.isMobile = window.innerWidth < 768
            this.isTablet = window.innerWidth <= 1024
            this.computeLevelPositions()
        },
        getCurrentLevel() {
            this.$store.dispatch(GET_CURRENT_LEVEL_USER).then(res => {
                if (!res.error) {
                    this.currentLevel = res.data?.current_level?.category_name ?? 'Trainee'
                }
            })
        },
        computeLevelPositions() {
            const container = this.$el.querySelector('.career-roadmap')
            const svg = this.$el.querySelector('.roadmap-svg')
            const path = this.$el.querySelector('#roadmap-path')
            if (!container || !svg || !path) {
                setTimeout(() => this.computeLevelPositions(), 100)
                return
            }
            if (svg.getBoundingClientRect().width === 0 || svg.getBoundingClientRect().height === 0) {
                setTimeout(() => this.computeLevelPositions(), 100)
                return
            }
            const total = path.getTotalLength()
            const rectContainer = container.getBoundingClientRect()
            const ctm = svg.getScreenCTM && svg.getScreenCTM()
            const svgPoint = svg.createSVGPoint ? svg.createSVGPoint() : null
            const levelStops = this.isSpecial ? this.levelStopsSpecial : this.levelStops
            const levels = levelStops.map((stop, idx) => {
                const t = typeof stop === 'number' ? stop : (stop && typeof stop === 'object' && typeof stop.t === 'number' ? stop.t : 0)
                const offset = (stop && typeof stop === 'object' && stop.offset) ? stop.offset : { x: 0, y: 0 }
                const offsetSpace = (stop && typeof stop === 'object' && stop.offsetSpace) ? stop.offsetSpace : 'svg'
                const normalDist = (stop && typeof stop === 'object' && typeof stop.normal === 'number') ? stop.normal : 0
                const len = total * t
                const p = path.getPointAtLength(len)
                let nx = 0, ny = 0
                if (normalDist !== 0) {
                    const delta = Math.max(0.5, total * 0.0005)
                    const p2 = path.getPointAtLength(Math.min(total, Math.max(0, len + delta)))
                    const tx = p2.x - p.x
                    const ty = p2.y - p.y
                    const tl = Math.hypot(tx, ty) || 1
                    nx = (-ty / tl) * normalDist
                    ny = (tx / tl) * normalDist
                }
                let px = p.x + nx + (offsetSpace === 'svg' ? (offset.x || 0) : 0)
                let py = p.y + ny + (offsetSpace === 'svg' ? (offset.y || 0) : 0)
                let sx = px
                let sy = py
                if (svgPoint && ctm) {
                    svgPoint.x = px
                    svgPoint.y = py
                    const screen = svgPoint.matrixTransform(ctm)
                    sx = screen.x - rectContainer.left
                    sy = screen.y - rectContainer.top
                }
                if (offsetSpace === 'screen') {
                    sx += (offset.x || 0)
                    sy += (offset.y || 0)
                }
                return {
                    id: idx + 1,
                    img: this.levelImages[idx + 1],
                    position: { x: sx, y: sy }
                }
            })
            this.levels = levels
        }
    }
}
</script>

<style scoped>
.career-page {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.career-page__meta {
    display: flex;
    justify-content: flex-end;
}

.career-page__date {
    display: inline-flex;
    align-items: center;
    padding: 10px 16px;
    border-radius: 999px;
    background: linear-gradient(135deg, #f4f1ff 0%, #ffffff 100%);
    border: 1px solid rgba(80, 54, 148, 0.12);
    color: #4b3b7a;
    font-weight: 600;
    box-shadow: 0 12px 30px rgba(73, 49, 147, 0.08);
}

.career-wrapper {
    width: 100%;
}

.career-roadmap {
    margin-top: 100px;
    position: relative;
    width: 100%;
    aspect-ratio: 1422 / 702;
}

.employee-level {
    width: 78px;
    height: 78px;
    border-radius: 50%;
    object-fit: cover;
}

.career-container {
    position: relative;
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 24px;
    align-items: start;
}

.career-title {
    position: absolute;
    top: -40px;
    left: 0;
    display: flex;
    flex-direction: column;
    z-index: 2;
}

.gradient-text {
    font-weight: 700;
    font-size: 50px;
    text-transform: uppercase;
    background: linear-gradient(to bottom right, #afa4f7 0%, #503694 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
}

.career-notification {
    margin-top: -30px;
    margin-bottom: 50px;
}

.career-dashboard {
    width: 100%;
}

.career-dashboard__grid {
    align-items: stretch;
}

.career-summary {
    height: 100%;
}

.career-summary__title {
    margin-bottom: 20px;
    font-size: clamp(28px, 3vw, 38px);
    line-height: 1.2;
    color: #20233a;
}

.career-summary__title span {
    color: #493193;
    font-weight: 700;
}

.career-summary__card {
    width: 100%;
    max-width: 360px;
    overflow: hidden;
    border-radius: 24px;
    box-shadow: 0 18px 45px rgba(237, 165, 52, 0.2);
}

.career-summary__body {
    padding: 24px;
}

.career-summary__body h1 {
    font-size: clamp(24px, 2.5vw, 34px);
    line-height: 1.2;
}

.career-summary__badge {
    font-size: 18px;
}

.career-summary__link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 24px;
    font-weight: 600;
}

.career-mobile {
    padding-top: 36px;
}

@media only screen and (max-width: 1024px) {
    .career-container {
        grid-template-columns: 1fr;
    }

    .career-title {
        position: static;
        margin-bottom: 8px;
    }

    .career-roadmap {
        margin-top: 0;
    }

    .career-notification {
        margin-top: 0;
        margin-bottom: 32px;
    }

    .gradient-text {
        font-size: 30px;
    }
}

@media only screen and (max-width: 767px) {
    .career-page {
        gap: 16px;
    }

    .career-page__meta {
        justify-content: center;
    }

    .career-page__date {
        width: 100%;
        justify-content: center;
        text-align: center;
    }

    .employee-level {
        width: 60px;
        height: 60px;
    }

    .special-notification {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 14px;
        padding: 20px 16px;
        border-radius: 24px;
        background: linear-gradient(135deg, #ffffff 0%, #f3efff 100%);
        box-shadow: 0 18px 45px rgba(73, 49, 147, 0.12);
    }

    .message-user {
        flex: 1;
        border: 1px solid rgba(80, 54, 148, 0.12);
        background: white;
        border-radius: 18px;
        padding: 14px;
        color: #2b2f42;
        box-shadow: 0 10px 24px rgba(73, 49, 147, 0.08);
    }

    .career-summary__card {
        max-width: none;
    }

    .career-summary__body {
        padding: 20px;
    }

    .career-summary__link {
        padding: 12px 20px;
    }
}

@media only screen and (max-width: 575px) {
    .special-notification {
        flex-direction: column;
        text-align: center;
    }

    .message-user {
        width: 100%;
    }
}
</style>
